var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"folie"},[_c('v-container',[_c('v-card-title',{staticClass:"display-3"},[_vm._v(_vm._s(this.title))]),_c('v-card-text',{staticClass:"title",attrs:{"align":"start"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }